export default "__VITE_ASSET__da41de55__"